'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var Tooltip = require('./Tooltip.js');
var withStyles = require('../../Styles/withStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var styles = function styles(theme) {
  return {
    tooltip: {
      backgroundColor: theme.palette.white.primary,
      color: theme.palette.black.primary,
      boxShadow: theme.shadows[6],
      maxWidth: 150,
      padding: 12
    },
    popper: {
      opacity: 1
    }
  };
};

var InformativeTooltip = function InformativeTooltip(_ref) {
  var classes = _ref.classes,
      children = _ref.children,
      restOfProps = objectWithoutProperties(_ref, ["classes", "children"]);

  return React__default["default"].createElement(Tooltip, _objectSpread({
    classes: classes
  }, restOfProps), children);
};

var InformativeTooltip$1 = withStyles["default"](styles)(InformativeTooltip);

module.exports = InformativeTooltip$1;
